/* global cordova */
/* global intercom */
/* global gtag */
/* eslint-disable camelcase */

// React
import React from 'react'
import { connect } from 'react-redux'
// GraphQL
import { compose, graphql } from 'react-apollo'
// GraphQL queries
import { queryUser } from './graphql/queries/user'
// GraphQL mutations
import { loadIntercom } from './graphql/mutations/intercom'
// GraphQL subscriptions
import { userSubscription } from './graphql/subscriptions/user'
// Redux
import { logoutUser } from './redux/auth'
import { addPage, removePage, setPage, updatePage } from './redux/nav'
// Data
import { signs } from './data/signs'
// Components
import CompleteAccess from './Components/Payment/CompleteAccess'
import Contact from './Components/Home/Contact'
import Home from './Components/Home/Home'
import Loading from './Components/Display/Loading'
import Lookup from './Components/Home/Lookup'
import Reset from './Components/Auth/Reset'
import Relationships from './Components/Home/Relationships'
import Settings from './Components/Settings/Settings'
import Signin from './Components/Auth/Signin'
import Zodiac from './Components/Zodiac/All'
// Pages
import ColorScale from './Components/Pages/ColorScale'
import Compatibility from './Components/Pages/Compatibility'
import TimeAndPlace from './Components/Pages/TimeAndPlace'
import Welcome from './Components/Pages/Welcome'


// REDUX
const mapStateToProps = (state) => ({
	state: {
		nav: state.nav
	}
})

const mapDispatchToProps = (dispatch) => ({
	redux: {
		auth: {
			logoutUser: () => dispatch(logoutUser())
		},
		nav: {
			addPage: (page, data) => dispatch(addPage(page, data)),
			removePage: () => dispatch(removePage()),
			setPage: (page, data) => dispatch(setPage(page, data)),
			updatePage: (page, data) => dispatch(updatePage(page, data))
		}
	}
})


// COMPONENT
class Start extends React.Component {

	componentWillMount() {
		// INTERCOM: Make sure Intercom is not seen to be active yet.
		window.localStorage.removeItem('MoonSignApp:intercom')
		// CORDOVA
		if (process.env.REACT_APP_ENV === 'ios' || process.env.REACT_APP_ENV === 'android') {
			window.open = cordova.InAppBrowser.open
		}
	}

	componentDidMount() {
		// SET CORRECT PAGE DATA: If page is loaded via url, set Page in web app to reflect url.
		const { nav } = this.props.state
		const { page } = nav[nav.length-1]
		const url = window.location.pathname.substr(1)
		if (page !== url) {
			this.props.redux.nav.setPage(url)
		}
	}

	componentWillReceiveProps(nextProps) {
		// USER SUBSCRIPTION
		if (!nextProps.data.loading && nextProps.data.user) {
			const { user } = nextProps.data
			this.userSubscription = nextProps.data.subscribeToMore({
				document: userSubscription,
				variables: { userId: user.id },
				updateQuery: (previousState, { subscriptionData }) => nextProps.data.refetch(),
				onError: (err) => console.error(err)
			})
		}
		// INTERCOM: load only for authenticated users
		if (nextProps.data.user && !window.localStorage.getItem('MoonSignApp:intercom')) {
			this.loadIntercom(nextProps.data.user)
		}
		// URL. Change url if page has been set, added, or removed
		const url = window.location.pathname.substr(1)
		const { nav } = nextProps.state
		const { page } = nav[nav.length-1]
		if (page !== url) {
			window.history.pushState('', '', '/' + page)
			// GOOGLE ANALYTICS
			gtag('config', 'UA-47052097-15', {
				'page_title' : page,
				'page_path': page
			})
		}
	}

	loadIntercom = (user) => {
		// INTERCOM
		this.props.loadIntercom({ variables: { email: user.email, platform: process.env.REACT_APP_ENV } })
			.then(({ data }) => {
				console.log('Loading Intercom');
				if (data.loadIntercom) {
					// Get hash
					const { hash } = data.loadIntercom
					// Prevent Intercom from reloading in the future
					window.localStorage.setItem('MoonSignApp:intercom', true)
					// If Cordova: iOS or Android
					if (process.env.REACT_APP_ENV === 'ios' || process.env.REACT_APP_ENV === 'android') {
						intercom.reset()
						intercom.setUserHash(hash)
						intercom.registerIdentifiedUser({ userId: user.id })
						intercom.updateUser({
							created_at: new Date(user.createdAt),
							email: user.email,
							name: user.nameFirst + ' ' + user.nameLast,
							custom_attributes: {
								'First name': user.nameFirst,
								'Last name': user.nameLast,
								'Paid': user.accountPaid,
								'App name': process.env.REACT_APP_NAME,
								'App version': process.env.REACT_APP_VERSION,
								'App env': process.env.REACT_APP_ENV
							}
						})
						// iOS specifically
						if (process.env.REACT_APP_ENV === 'ios') {
							intercom.registerForPush()
						}
					}
					// If web
					else {
						window.Intercom('shutdown')
						window.Intercom('boot', {
							app_id: 'kkq5mzex',
							user_id: user.id,
							user_hash: hash,
							created_at: new Date(user.createdAt),
							email: user.email,
							name: user.nameFirst + ' ' + user.nameLast,
							'First name': user.nameFirst,
							'Last name': user.nameLast,
							'Paid': user.accountPaid,
							'App name': process.env.REACT_APP_NAME,
							'App version': process.env.REACT_APP_VERSION,
							'App env': process.env.REACT_APP_ENV,
							custom_launcher_selector: '#intercom-support',
							hide_default_launcher: true
						})
					}
				}
			})
			.catch((err) => console.error(err))
	}

	organizeProps = () => {
		// PROPS
		let props = Object.assign({}, this.props)
		// Remove intercom
		if (props.loadIntercom) {
			delete props.loadIntercom
		}
		// Move user data into props
		if (props.data.user) {
			let user = Object.assign({}, props.data.user)
			delete props.data.user
			delete user.__typename
			props.user = user
		}
		// Add refetch to props
		if (props.data.refetch) {
			props.refetch = props.data.refetch
		}
		// Add subscription
		if (props.data.subscribeToMore) {
			props.subscription = props.data.subscribeToMore
		}
		// Remove unused props
		if (props.store) delete props.store
		if (props.storeSubscription) delete props.storeSubscription
		if (props.data) delete props.data
		return props
	}

	logger = (page, props) => {
		if (process.env.NODE_ENV === 'development') {
			console.group('%c Page', 'font-weight:700; color:#00AA00')
			console.log(page)
			console.groupEnd()
			console.group('%c Props', 'font-weight:700; color:#AA0000')
			console.log(props)
			console.groupEnd()
		}
	}

	selectComponent = () => {
		// PROPS
		const props = this.organizeProps()
		// LOGGER
		const { nav } = this.props.state
		let { page, data } = nav[nav.length-1]
		this.logger(page, props)
		// COMPONENTS
		// Custom pages
		if (localStorage.getItem('MoonSignApp:colorScale'))					return <ColorScale {...props} />
		if (localStorage.getItem('MoonSignApp:compatibility'))	return <Compatibility {...props} />
		if (localStorage.getItem('MoonSignApp:timeAndPlace'))				return <TimeAndPlace {...props} />
		if (localStorage.getItem('MoonSignApp:welcome'))						return <Welcome {...props} />
		// Components
		// Zodiac
		if (signs.filter((sign) => (sign.sign === page)).length === 1) {
			data = { name: page, ...data }
			page = 'zodiac'
		}
		// If authenticated page is called without being authenticated, go to home page
		const publicPages = ['', 'confirm', 'login', 'reset', 'zodiac']
		if (!props.user && !publicPages.includes(page)) {
			window.history.pushState('', '', '/')
			window.location.reload()
		}
		// If password reset is called, remove authentication token
		if (page === 'reset') {
			window.localStorage.removeItem('MoonSignApp:login')
		}
		const allProps = Object.assign(props, data)
		switch (page) {
		case '':							return <Home {...allProps} />
		case 'add':						return <Contact {...allProps} />
		case 'confirm':				return <Signin {...allProps} />
		case 'contact':				return <Contact {...allProps} />
		case 'login':					return <Signin {...allProps} />
		case 'lookup':				return <Lookup {...allProps} />
		case 'relationships':	return <Relationships {...allProps} />
		case 'reset':					return <Reset {...allProps} />
		case 'settings':			return <Settings {...allProps} />
		case 'upgrade':				return <CompleteAccess {...allProps} />
		case 'zodiac':				return <Zodiac {...allProps} />
		default:							return <Home {...allProps} />
		}
	}

	render() {
		if (this.props.data.loading) {
			return <Loading status={true} text='loading...' />
		}
		return (
			<div className='capps-responsive'>
				{this.selectComponent()}
			</div>
		)
	}
}

export default
connect(mapStateToProps, mapDispatchToProps)(
	compose(
		graphql(queryUser, { options: { fetchPolicy: 'cache-first' } }),
		graphql(loadIntercom, { name: 'loadIntercom' })
	)(Start)
)



// WEBPACK FOOTER //
// ./src/Start.js